/**
 * Create colorStyles based on the passed in theme
 *
 * @param {Object} theme The passed in theme
 *
 * @returns {Object} The generated colorStyles
 */
export var createColorStyles = function createColorStyles() {
  var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _theme$colors = theme.colors,
      white = _theme$colors.white,
      text = _theme$colors.text,
      gray = _theme$colors.gray,
      lightGray = _theme$colors.lightGray,
      blue = _theme$colors.blue,
      lightBlue = _theme$colors.lightBlue,
      green = _theme$colors.green,
      lightGreen = _theme$colors.lightGreen,
      red = _theme$colors.red,
      lightRed = _theme$colors.lightRed,
      orange = _theme$colors.orange,
      purple = _theme$colors.purple,
      lightPurple = _theme$colors.lightPurple,
      darkOrange = _theme$colors.darkOrange;
  return {
    whiteOnText: {
      color: white,
      backgroundColor: text
    },
    whiteOnGray: {
      color: white,
      backgroundColor: gray
    },
    textOnLightGray: {
      color: text,
      backgroundColor: lightGray
    },
    whiteOnBlue: {
      color: white,
      backgroundColor: blue
    },
    blueOnLightBlue: {
      color: blue,
      backgroundColor: lightBlue
    },
    whiteOnGreen: {
      color: white,
      backgroundColor: green
    },
    greenOnLightGreen: {
      color: green,
      backgroundColor: lightGreen
    },
    whiteOnRed: {
      color: white,
      backgroundColor: red
    },
    redOnLightRed: {
      color: red,
      backgroundColor: lightRed
    },
    textOnOrange: {
      color: text,
      backgroundColor: orange
    },
    whiteOnPurple: {
      color: white,
      backgroundColor: purple
    },
    purpleOnLightPurple: {
      color: purple,
      backgroundColor: lightPurple
    },
    textOnWhite: {
      color: text,
      backgroundColor: white
    },
    grayOnWhite: {
      color: gray,
      backgroundColor: white
    },
    blueOnWhite: {
      color: blue,
      backgroundColor: white
    },
    greenOnWhite: {
      color: green,
      backgroundColor: white
    },
    redOnWhite: {
      color: red,
      backgroundColor: white
    },
    purpleOnWhite: {
      color: purple,
      backgroundColor: white
    },
    whiteOnDarkOrange: {
      color: white,
      backgroundColor: darkOrange
    },
    info: {
      color: text,
      backgroundColor: lightGray
    },
    success: {
      color: white,
      backgroundColor: green
    },
    warning: {
      color: text,
      backgroundColor: orange
    },
    danger: {
      color: white,
      backgroundColor: red
    }
  };
};